import React from 'react';

type LoanStatus = 'active' | 'pending' | 'approved' | 'paid' | 'overdue' | 'written-off';
type TransactionType = 'contribution' | 'disbursement' | 'repayment' | 'distribution' | 'adjustment';

interface StatusBadgeProps {
  status: LoanStatus | TransactionType | string;
  size?: 'sm' | 'md';
}

const statusMap: Record<string, { label: string; className: string }> = {
  active: { label: 'Active', className: 'badge-active' },
  pending: { label: 'Pending', className: 'badge-pending' },
  approved: { label: 'Approved', className: 'badge-approved' },
  paid: { label: 'Paid', className: 'badge-paid' },
  overdue: { label: 'Overdue', className: 'badge-overdue' },
  'written-off': { label: 'Written Off', className: 'badge-written-off' },
  contribution: { label: 'Contribution', className: 'badge-approved' },
  disbursement: { label: 'Disbursement', className: 'badge-pending' },
  repayment: { label: 'Repayment', className: 'badge-active' },
  distribution: { label: 'Distribution', className: 'badge-paid' },
  adjustment: { label: 'Adjustment', className: 'badge-written-off' },
};

export default function StatusBadge({ status, size = 'sm' }: StatusBadgeProps) {
  const config = statusMap[status.toLowerCase()] ?? {
    label: status,
    className: 'badge-written-off',
  };

  const sizeClass = size === 'sm' ? 'text-[10px] px-2 py-0.5' : 'text-xs px-2.5 py-1';

  return (
    <span className={`inline-flex items-center rounded-full font-semibold tracking-wide ${sizeClass} ${config.className}`}>
      {config.label}
    </span>
  );
}